import React from 'react';
import './AboutUs.css'; // Ensure this is linked properly
import { Link } from 'react-router-dom';

const AboutUs = () => {
  return (
    <div className="about-container">
      <header className="about-header1">
        <div className="header-content1">
          <h1>A Luxuries Marriage Garden & Resort</h1>
          <h2>Creating Magical Moments, One Wedding at a Time</h2>
          <p>Reserve Your Perfect Venue Today, Celebrate Tomorrow!</p>
           
          <Link to="/contact"><button className="explore-button" >BOOK NOW</button></Link>
        </div>
      </header>
      <div className="about-body">
        <div className="about-description">
          <h2 className="main-title1">THE GOLDEN PALACE - ABOUT US</h2>
          <p>Welcome to The Golden Palace, a luxurious marriage garden and resort located  Didwana (341303), Rajasthan, India. Here, your dreams come true amidst the beauty of nature. Our venue offers an enchanting setting for weddings, celebrations, and unforgettable moments. With sprawling gardens, elegant décor, and a pristine swimming pool, we provide the perfect backdrop for your special day.

At The Golden Palace, we believe every wedding should be a fairy tale, and we are committed to making yours magical. Whether you're planning an intimate gathering or a grand celebration, our expert team is here to ensure your event is flawless. From the lush garden to the luxurious resort facilities, every detail is designed with your comfort and happiness in mind.

Let us help you create memories that will last a lifetime at The Golden Palace—where luxury meets love.</p>
          <h2 style={{fontStyle:"italic", color:"grey"}}>Perfect place for Destination Wedding.....</h2>
        </div>
        <div className="about-Quicklinks"><br/>
          <h2>Quick Links</h2>
          <ul>
          <li><Link  style={{textDecoration:"none" ,color:"black"}}  to="/contact">Contact us</Link></li>
            <li><Link style={{textDecoration:"none" ,color:"black"}} to="/vision&mission">Accommodation</Link></li>
            <li><Link  style={{textDecoration:"none" ,color:"black"}}  to="/leadership">Banquite facilities</Link></li>
            <li><Link  style={{textDecoration:"none" ,color:"black"}}  to="/corevalue">Recreational facilities</Link></li>
            <li><Link  style={{textDecoration:"none", color:"black"}}  to="/recognitionsandapprovals">Amenities</Link></li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
